import React from "react"

import styles from "./post-content.module.css"

export default function postContent({ children, className }) {
  return (
    <div className={`row ${styles.postContent}`}>
      <div className={className}>{children}</div>
    </div>
  )
}
